import React, { Component } from 'react'
import cx from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as _ from 'lodash'
// shared component used by WaiterOptionGroups and WaiterStepper to display boxes for waiter
class WaiterStepperItem extends Component {
  constructor (props) {
    super(props)
    this.state = {
      highlight: false,
    }
  }

  handleHighlightFade = (ms = 150) => {
    setTimeout(() => this.setState({ highlight: false }), ms)
  }

  renderPriceDiscount = (original, discount) => {
    const { classes } = this.props
    const listPriceDiscountAmountStyle = cx(classes['list-price-discount-amount'])

    // discount === 0 ( NO Discount )
    // discount > 0 ( SHOW Discount )
    if (discount !== 0 && discount <= original) {
      return (
        <div className={listPriceDiscountAmountStyle}>
          <FontAwesomeIcon icon='dollar-sign' />
          {original}
        </div>
      )
    }
  };

  renderPricePrefix = (price) => {
    const { classes } = this.props
    const listPricePrefixStyle = cx(classes['list-price-prefix'])

    if (price && price !== 0 && price !== '0') {
      return (
        <div className={listPricePrefixStyle}>
          <FontAwesomeIcon icon='dollar-sign' />
        </div>
      )
    }
  };

  renderPrice = (original, discount) => {
    const {
      classes,
    } = this.props

    // discount === 0 ( NO Discount )
    // discount > 0 ( SHOW Discount )
    if (original !== 0) {
      const listPriceAmountStyle = cx(classes['list-price-amount'])
      const priceAmountStyle = (discount !== 0)
        ? { color: '#C54545' }
        : { color: '#614D4A' }
      return (
        <span className={listPriceAmountStyle} style={priceAmountStyle}>
          {original - discount}
        </span>
      )
    }
  };

  // > 若 commodity 為套餐則引導到套餐頁面 (order.dishId)
  jumpToCategory = (categoryId) => {
    const { history } = this.props
    const path = '/category/set/' + categoryId
    history.push(path)
    console.info('route changed', path)
  }

  isGroupLocked = groupId => {
    let count = 0
    _.each(window.groupMap[groupId], v => {
      count += v
    })
    return count > 0
  }

  render () {
    const {
      commodity,
      onAddBtnClick,
      onMinusBtnClick,
      classes,
      intl,
      name,
      price,
      currentQty,
      discount,
      priceUndetermined,
      shouldShowOverlay,
      sold,
      customizedCode,
      updateSearchModeDisplay, // > display search mode. (false)
    } = this.props

    const groupId = window.itemGroupMap[this.props.itemId]
    const locked = this.isGroupLocked(groupId)

    // JSS
    const listPriceAmountStyle = cx(classes['list-price-amount'])
    const listPriceUndeterminedStyle = cx(classes['list-price-undetermined'])
    const itemOptionDisableOverlayStyle = cx(classes['item-option-disable-overlay'])
    const priceAmountStyle = (discount !== 0) ? { color: '#C54545' } : { color: '#614D4A' }
    const currentQuantityLabelStyle = cx(classes['current-quantity-label'])
    const customizedCodeLabelStyle = cx(classes['customizedCode-label-style'])
    const soldOutLabelStyle = cx(classes['sold-out-label-style'])
    const minusButtonStyle = cx(classes['minus-button'])
    const waiterStepperItemContainerStyle = cx(classes['waiter-stepper-item-container'], { [classes['highlight-backgound']]: this.state.highlight })
    const waiterStepperItemTopStyle = cx(classes['waiter-stepper-item-top'])
    const waiterStepperItemBottomStyle = cx(classes['waiter-stepper-item-bottom'])
    const priceLabelsContainerStyle = cx(classes['price-labels-container'])
    const titleContainerStyle = cx(classes['title-container'], classes['list-item-name'])

    // Intl
    const soldText = sold ? intl.formatMessage({ id: 'stepper.sold_out' }) : ''
    const undeterminedPriceText = intl.formatMessage({ id: 'summary.undetermined.price' })
    const MinusText = intl.formatMessage({ id: 'minus' })

    // Labels
    const currentQtyLabel = (currentQty > 0) && (
      <div className={currentQuantityLabelStyle}>
        {currentQty}
      </div>
    )

    const priceLabel = priceUndetermined
      ? (
        <div className={listPriceUndeterminedStyle}>
          {undeterminedPriceText}
        </div>
      )
      : (
        <div className={listPriceAmountStyle} style={priceAmountStyle}>
          {this.renderPrice(price, discount)}
        </div>
      )

    const optionOverlayElement = (shouldShowOverlay || locked) && (
      <div className={itemOptionDisableOverlayStyle} onClick={() => { }} />
    )

    const customizedCodeLabel = customizedCode && (
      <div className={customizedCodeLabelStyle}>
        {customizedCode}
      </div>
    )

    const soldOutLabel = sold && (
      <div className={soldOutLabelStyle}>
        {soldText}
      </div>
    )

    const minusButton = (
      <div
        className={minusButtonStyle}
        onTouchStart={() => { this.setState({ highlight: true }) }}
        onTouchEnd={() => this.handleHighlightFade()}
        onClick={(e) => {
          if (!e) {
            const e = window.event
            e.cancelBubble = true
            if (e.stopPropagation) {
              e.stopPropagation()
            }
          } else {
            e.cancelBubble = true
            if (e.stopPropagation) {
              e.stopPropagation()
            }
          }
          if (currentQty > 0) {
            onMinusBtnClick()
          }
        }}
      > {MinusText}
      </div>
    )

    return (
      <div
        id={name}
        ref={ref => { this.ref = ref }}
        className={waiterStepperItemContainerStyle}
        style={{
          ...sold && {
            opacity: '0.7',
            // backgroundColor: '#F17C6740',
          },
        }}
        onTouchStart={() => { this.setState({ highlight: true }) }}
        onTouchEnd={() => this.handleHighlightFade()}
        onClick={(e) => {
          if (locked || sold) return

          if (!e) {
            const e = window.event
            e.cancelBubble = true
            if (e.stopPropagation) e.stopPropagation()
          } else {
            e.cancelBubble = true
            if (e.stopPropagation) e.stopPropagation()
          }

          // > 再這裡判斷是否為套餐，是則 jumpToCategory()
          if (commodity && commodity.step) {
            this.jumpToCategory(commodity.categoryId)
            updateSearchModeDisplay(false)
          } else if (commodity && commodity.isSet) {
            this.jumpToCategory(commodity.id)
            updateSearchModeDisplay(false)
          } else {
            onAddBtnClick()
          }
        }}
      >
        {optionOverlayElement}
        <div className={waiterStepperItemTopStyle}>

          <div className={titleContainerStyle}>
            {customizedCodeLabel}
            {name}
            {soldOutLabel}
          </div>
          {currentQtyLabel}
        </div>

        {/* bottom */}
        <div className={waiterStepperItemBottomStyle}>
          {minusButton}

          {/* right */}
          {
            <div className={priceLabelsContainerStyle}>
              {this.renderPriceDiscount(price, discount)}
              <div>
                {this.renderPricePrefix(price)}
                {priceLabel}
              </div>
            </div>
          }

        </div>
      </div>)
  }
}

export default WaiterStepperItem



// WEBPACK FOOTER //
// ./src/components/WaiterStepperItem.js